import { useEffect } from "react";

/*
  Holds the page still while a modal is open.

  Every modal used to do this itself — `document.documentElement.style.overflow
  = "hidden"` on mount, back to "unset" on unmount. That works for one modal and
  breaks for two, because the flag is global and the second one to CLOSE is not
  the last one still open.

  Edit Asset hits this every save: it renders <OnProgress> inside itself, and
  OnProgress locks and unlocks the same flag. The moment progress finishes, the
  page is unlocked again while the asset modal is still very much open.

  So the lock is counted here instead. The first modal to ask for it takes it,
  the last to let go returns it, and the value that was there beforehand is put
  back rather than assumed to be "unset" — App.jsx sets overflow-y/overflow-x
  deliberately and should get them back untouched.
*/

// Shared across every caller — the whole point of the module.
let holders = 0;
let previous = null;

export const useScrollLock = (active = true) => {
  useEffect(() => {
    if (!active) return undefined;

    if (holders === 0) {
      const { style } = document.documentElement;
      // The inline value as it stands, so the restore is exact.
      previous = style.overflow;
      style.overflow = "hidden";
    }
    holders += 1;

    return () => {
      holders -= 1;
      if (holders === 0) {
        document.documentElement.style.overflow = previous || "";
        previous = null;
      }
    };
  }, [active]);
};

export default useScrollLock;
